$(document).on('turbolinks:load', function () {
    buttons = $('a.row-button')
    buttons.on('click', (event) => {
        event.stopPropagation();
    })
})